import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';

import ga from '../../../analytics';
import { createQuestion, closeModal, isHelpModalOpenSelector } from '../redux';

const mapStateToProps = state => ({ isOpen: isHelpModalOpenSelector(state) });
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { createQuestion, closeHelpModal: () => closeModal('help') },
    dispatch
  );

const propTypes = {
  closeHelpModal: PropTypes.func.isRequired,
  createQuestion: PropTypes.func.isRequired,
  isOpen: PropTypes.bool
};

const RSA =
  'https://quest.ac';

export class HelpModal extends PureComponent {
  render() {
    const { isOpen, closeHelpModal, createQuestion } = this.props;
    if (isOpen) {
      ga.modalview('/help-modal');
    }
    return (
      <Modal onHide={closeHelpModal} show={isOpen}>
        <Modal.Header
          className='help-modal-header fcc-modal'
          closeButton={true}
          >
          <Modal.Title className='text-center'>Even the master had his first step.</Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-center'>
          <h3>
            Everyone can code &nbsp;
            <a href={RSA} target='_blank' title='Read, search, ask'>
              Read-Search-Ask
            </a>&nbsp; You can ask the community for help!
          </h3>
          <Button
            block={true}
            bsSize='lg'
            bsStyle='primary'
            onClick={createQuestion}
            >
            Post request for help
          </Button>
          <Button
            block={true}
            bsSize='lg'
            bsStyle='primary'
            onClick={closeHelpModal}
            >
            Found a solution and I'm good.
          </Button>
        </Modal.Body>
      </Modal>
    );
  }
}

HelpModal.displayName = 'HelpModal';
HelpModal.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(HelpModal);



// WEBPACK FOOTER //
// ./src/templates/Challenges/components/HelpModal.js